// extracted by mini-css-extract-plugin
export var chip = "_cr-0";
export var filterDropdown = "_cr-5";
export var filterItem = "_cr-6";
export var icon = "_cr-1";
export var removeButton = "_cr-3";
export var removeIcon = "_cr-4";
export var separator = "_cr-2";